module.exports = __webpack_public_path__ + "img/CW_Robert_Ellis+St_Vincent-4294.e16ba64c.jpg";